type LogLevel = "debug" | "info" | "warn" | "error" | "silent";

const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 10,
  info: 20,
  warn: 30,
  error: 40,
  silent: 50,
};

const normalizeLogLevel = (value: unknown): LogLevel | null => {
  const normalized = String(value || "").toLowerCase();
  return normalized in LOG_LEVELS ? (normalized as LogLevel) : null;
};

type RuntimeImportMeta = ImportMeta & {
  env?: {
    VITE_LOG_LEVEL?: unknown;
    DEV?: boolean;
  };
};

const env = (import.meta as RuntimeImportMeta).env;
const configuredLevel = normalizeLogLevel(env?.VITE_LOG_LEVEL) ?? (env?.DEV ? "debug" : "warn");

const shouldLog = (level: LogLevel) => LOG_LEVELS[level] >= LOG_LEVELS[configuredLevel];

export const logger = {
  debug: (...args: unknown[]) => {
    if (shouldLog("debug")) console.debug(...args);
  },
  info: (...args: unknown[]) => {
    if (shouldLog("info")) console.info(...args);
  },
  warn: (...args: unknown[]) => {
    if (shouldLog("warn")) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    if (shouldLog("error")) console.error(...args);
  },
};

export const getLogLevel = () => configuredLevel;
